// extracted by mini-css-extract-plugin
export var input = "BreakSlugField-module--input--d4f9d";
export var label = "BreakSlugField-module--label--ce504";
export var row = "BreakSlugField-module--row--3b6c0";